import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editMissionAction = createAsyncThunk(
    'create-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/edit-mission`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editMissionSlice = createSlice({
    name: 'create-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editMissionReducer = editMissionSlice.reducer    